import React, { useState } from "react";
import { Pencil, Trash2, Check, X } from "lucide-react";
import { adminUpdateWorklog } from "../api";

const inp = "h-8 rounded-lg border border-slate-200 px-2 text-sm bg-white";

export const WorklogRow = ({ w, onDelete, onSaved }) => {
  const [edit, setEdit] = useState(null);
  const save = async () => {
    if (!edit.hours) return alert("Bitte Stunden angeben.");
    try {
      await adminUpdateWorklog(w.booking_id, w.id, { date: edit.date, hours: Number(edit.hours), note: edit.note, location: edit.location });
      setEdit(null); onSaved();
    } catch (e) { alert("Fehler: " + (e.response?.data?.detail || e.message)); }
  };
  const set = (k) => (e) => setEdit({ ...edit, [k]: e.target.value });

  if (edit) return (
    <tr data-testid={`worklog-edit-row-${w.id}`} className="border-b border-slate-50 bg-amber-50/40">
      <td className="px-4 py-2"><input data-testid="worklog-edit-date" type="date" value={edit.date} onChange={set("date")} className={inp} /></td>
      <td className="px-4 py-2 font-medium text-slate-900">{w.cleaner}</td>
      <td className="px-4 py-2">{w.customer}</td>
      <td className="px-4 py-2">{w.city}</td>
      <td className="px-4 py-2"><input value={edit.location} onChange={set("location")} className={`${inp} w-full`} /></td>
      <td className="px-4 py-2"><input data-testid="worklog-edit-hours" type="number" min="0.25" max="24" step="0.25" value={edit.hours} onChange={set("hours")} className={`${inp} w-20`} /></td>
      <td className="px-4 py-2"><input data-testid="worklog-edit-note" value={edit.note} onChange={set("note")} className={`${inp} w-full`} /></td>
      <td className="px-4 py-2 text-right whitespace-nowrap">
        <button data-testid="worklog-edit-save" onClick={save} title="Speichern" className="text-teal-700 hover:text-teal-900 mr-2"><Check className="w-4 h-4" /></button>
        <button data-testid="worklog-edit-cancel" onClick={() => setEdit(null)} title="Abbrechen" className="text-slate-400 hover:text-slate-700"><X className="w-4 h-4" /></button>
      </td>
    </tr>
  );

  return (
    <tr className="border-b border-slate-50 hover:bg-slate-50/60">
      <td className="px-4 py-3 whitespace-nowrap">{w.date}</td>
      <td className="px-4 py-3 font-medium text-slate-900">{w.cleaner}</td>
      <td className="px-4 py-3">{w.customer}</td>
      <td className="px-4 py-3">{w.city}</td>
      <td className="px-4 py-3 text-slate-600">{w.location}</td>
      <td className="px-4 py-3 font-semibold text-teal-700">{w.hours}</td>
      <td className="px-4 py-3 text-slate-500">{w.note}{w.by_admin && <span className="ml-2 text-[10px] font-semibold uppercase bg-slate-100 text-slate-500 rounded px-1.5 py-0.5">Admin</span>}</td>
      <td className="px-4 py-3 text-right whitespace-nowrap">
        {w.id && <>
          <button data-testid={`worklog-edit-${w.id}`} onClick={() => setEdit({ date: w.date || "", hours: w.hours, note: w.note || "", location: w.location || "" })} title="Korrigieren" className="text-slate-400 hover:text-teal-700 mr-3"><Pencil className="w-4 h-4" /></button>
          <button data-testid={`worklog-delete-${w.id}`} onClick={() => onDelete(w)} title="Eintrag löschen" className="text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
        </>}
      </td>
    </tr>
  );
};
